import React from 'react';
import cx from 'classnames';

import styles from './Flags.module.scss';

export interface Props {
  className?: Parameters<typeof cx>[0];
}

export const US: React.FC<Props> = ({ className }) => (
  <i className={cx(styles.icon, className)}>
    <svg width={25} height={25} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M24.5 4H.5v15.998h24V4z' fill='#fff' />
        <path
          d='M24.5 6.002H.5v2.001h24V6.002zM24.5 10H.5v2.002h24V10zM24.5 14.003H.5v2.002h24v-2.002zM24.5 18.002H.5v2.001h24v-2.002z'
          fill='#D80027'
        />
        <path d='M12.5 4H.5v8.002h12V4z' fill='#2E52B2' />
        <path
          d='M5.178 7.53l-.192.595h-.624l.507.366-.197.595.506-.366.506.366-.192-.595.506-.366H5.37l-.192-.595zM5.37 10.272l-.192-.595-.192.595h-.624l.507.365-.197.596.506-.366.506.366-.192-.596.506-.365H5.37zM2.731 10.272l-.192-.595-.197.595H1.72l.506.365-.192.596.506-.366.502.366-.193-.596.507-.365H2.73zM2.54 7.53l-.198.595H1.72l.506.366-.192.595.506-.366.502.366-.193-.595.507-.366H2.73L2.54 7.53zM5.178 5.383l-.192.595h-.624l.507.37-.197.596.506-.37.506.37-.192-.596.506-.37H5.37l-.192-.595zM2.54 5.383l-.198.595H1.72l.506.37-.192.596.506-.37.502.37-.193-.596.507-.37H2.73l-.192-.595zM7.822 7.53l-.192.595h-.628l.506.366-.192.595.506-.366.506.366-.197-.595.507-.366h-.624l-.192-.595zM8.014 10.272l-.192-.595-.192.595h-.628l.506.365-.192.596.506-.366.506.366-.197-.596.507-.365h-.624zM10.658 10.272l-.197-.595-.192.595h-.624l.507.365-.193.596.502-.366.506.366-.192-.596.506-.365h-.623zM10.461 7.53l-.192.595h-.624l.507.366-.193.595.502-.366.506.366-.192-.595.506-.366h-.623l-.197-.595zM7.822 5.383l-.192.595h-.628l.506.37-.192.596.506-.37.506.37-.197-.596.507-.37h-.624l-.192-.595zM10.461 5.383l-.192.595h-.624l.507.37-.193.596.502-.37.506.37-.192-.596.506-.37h-.623l-.197-.595z'
          fill='#fff'
        />
      </g>
      <path d='M.5 4h24v16.003H.5z' stroke='#111' />
    </svg>
  </i>
);

US.displayName = 'US';
export default US;
